module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expected-ebitda"
  }, [_c('div', {
    staticClass: "expected-ebitda-box"
  }, [_c('div', {
    staticClass: "period"
  }, [_vm._v("\n            Forventet EBITDA i indeværende regnskabsår\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('div', [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("Forventet EBITDA (driftsoverskud)")]), _vm._v(" "), (_vm.data && !_vm.data.forecast) ? _c('div', {
    staticClass: "no-budget"
  }, [_vm._v("\n                    Hvis du lægger et budget i proEBITDA, vil du her kunne se, hvad regnskabsårets EBITDA med stor sandsynlighed vil blive. Kontakt os, hvis du har spørgsmål.\n                ")]) : _c('div', {
    staticClass: "large-title color-good"
  }, [(_vm.data) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.data.expected_ebitda)))]) : (_vm.error) ? _c('span', [_vm._v("-")]) : _c('span', [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })])])]), _vm._v(" "), (_vm.data && _vm.data.forecast) ? _c('div', {
    staticClass: "cta",
    on: {
      "click": function($event) {
        return _vm.$modal.show('expected-ebitda')
      }
    }
  }, [_vm._v("\n                Læs mere\n            ")]) : _vm._e()])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "expected-ebitda",
      "height": "auto",
      "adaptive": true,
      "scrollable": true,
      "width": "900"
    }
  }, [(_vm.data && _vm.data.forecast) ? _c('div', {
    staticClass: "expected-ebitda-modal"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('expected-ebitda')
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-times"
  })]), _vm._v(" "), _c('h3', [_vm._v("Sådan er tallet beregnet")]), _vm._v(" "), _c('div', {
    staticClass: "sub"
  }, [_vm._v("\n                Regnskabsåret " + _vm._s(_vm._f("moment")(_vm.data.accounting_year.from, "D. MMM YYYY")) + " - " + _vm._s(_vm._f("moment")(_vm.data.accounting_year.to, "D. MMM YYYY")) + ". Hold musen over "), _c('i', {
    staticClass: "fas fa-info-circle"
  }), _vm._v(" for at se mellemregningerne.\n            ")]), _vm._v(" "), _c('table', {
    staticClass: "calc"
  }, [_c('tr', [_c('td', [_vm._v("\n                        Realiseret EBITDA\n                        "), _c('calc-tooltip', {
    attrs: {
      "title": "Bogført og kassekladder",
      "lines": _vm.realizedLines
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "formula"
  }, [_vm._v("Bogført og kassekladder, regnskabsårets start til i dag")]), _vm._v(" "), _c('td', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.realized_ebitda)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                        Værdi af opgaver\n                        "), _c('calc-tooltip', {
    attrs: {
      "title": "Opgaver der ikke er faktureret færdig",
      "lines": _vm.wipLines
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "formula"
  }, [_vm._v(_vm._s(_vm.data.wip.ongoing_count + _vm.data.wip.unbilled_count) + " opgaver")]), _vm._v(" "), _c('td', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.wip.total)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                        Forventet resten af regnskabsåret\n                        "), _c('calc-tooltip', {
    attrs: {
      "title": "Kundetimer × DB pr. time over nulpunktsomsætning",
      "lines": _vm.forecastLines
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "formula"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.data.forecast.remaining_hours)) + " kundetimer × " + _vm._s(_vm._f("currency")(Math.abs(_vm.data.forecast.per_hour_above_break_even))) + " " + _vm._s(_vm.data.forecast.per_hour_above_break_even < 0 ? 'under' : 'over') + " nulpunktsomsætning")]), _vm._v(" "), _c('td', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.forecast.amount)))])]), _vm._v(" "), _c('tr', {
    staticClass: "sum"
  }, [_c('td', [_vm._v("Forventet EBITDA")]), _vm._v(" "), _c('td', {
    staticClass: "formula"
  }, [_vm._v("Realiseret + opgaver + resten af regnskabsåret")]), _vm._v(" "), _c('td', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.expected_ebitda)))])])]), _vm._v(" "), _c('div', {
    staticClass: "budget-note",
    class: _vm.aboveBudget ? 'is-good' : 'is-bad'
  }, [(_vm.cphDeviationPercent !== null) ? [_vm._v("\n                    Du ligger "), _c('b', [_vm._v(_vm._s(_vm.cphDeviationPercent) + " % " + _vm._s(_vm.cphDeviation < 0 ? 'under' : 'over'))]), _vm._v(" dit budget på DB pr. time.\n                ")] : _vm._e(), _vm._v("\n                Fortsætter du sådan, tjener du "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(Math.abs(_vm.data.forecast.budget_deviation))) + " " + _vm._s(_vm.aboveBudget ? 'mere' : 'mindre'))]), _vm._v(" end budgetteret resten af regnskabsåret.\n                "), _c('calc-tooltip', {
    attrs: {
      "title": "Sammenholdt med budgettet",
      "lines": _vm.comparisonLines
    }
  })], 2), _vm._v(" "), _c('ebitda-development', {
    staticClass: "development",
    attrs: {
      "months": _vm.data.months,
      "wip": _vm.data.wip
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e787f18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/components/expectedEbitda.vue
// module id = 912
// module chunks = 0